import Vue from "vue";
import VueRouter from "vue-router";
 
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import(/* webpackChunkName: "about" */ "../views/index.vue"),
    redirect: "/home", // 或其他目标路径
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "about" */ "../views/index.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/fail",
    name: "fail",
    component: () => import(/* webpackChunkName: "about" */ "../views/fail.vue"),
  },
  //success
  {
    path: "/success",
    name: "success",
    component: () => import(/* webpackChunkName: "about" */ "../views/success.vue"),
  },
  //404
  {
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName: "about" */ "../views/404.vue"),
  },
];

const router = new VueRouter({
  mode: "history", // 确保使用的是 "hash" 模式
  routes,
});

//设置路由模式不带#
export default router;
